import React, { Component } from 'react';
import { IntlProvider } from 'react-intl';

function getLocaleMessage(lang) {
  // eslint-disable-next-line @typescript-eslint/no-var-requires
  const result = require(`../../locales/${lang}.json`);
  return result;
}

class IntlProviderWrap extends Component {
  componentDidMount() {
    if (!localStorage.getItem('language')) {
      localStorage.setItem('language', 'vi');
    }
  }
  render() {
    const lang = localStorage.getItem('language') || 'vi';
    const messages = getLocaleMessage(lang);
    window.lang = lang;
    window.messages = messages;
    return (
      <IntlProvider key={lang} locale={lang} messages={messages}>
        {this.props.children}
      </IntlProvider>
    );
  }
}

export default IntlProviderWrap;
